export default __webpack_public_path__ + "static/media/add-doc-+img.6f212c0d.svg";